import Vue from 'vue';
import Router from 'vue-router';


import Signup from '@/modules/register/components/SignupForm.vue';
import LoginForm from '@/modules/login/components/LoginForm';
import SendResetTokenForm
  from '@/modules/passwordRecovery/components/SendResetTokenForm.vue';
import ResetPasswordForm
  from '@/modules/passwordRecovery/components/ResetPasswordForm.vue';
import ContactUsForm from '@/modules/contactUs/components/ContactUsForm';
import ErrorPage from '@/modules/error/components/ErrorModal';



import dashboardRoutes from '../modules/dashboardParent/routes';
import protocolRoutes from '../modules/protocols/routes';
import clientRoutes from '../modules/user/client/routes';
import profileRoutes from '../modules/profile/routes';
import therapistRoutes from '../modules/user/therapist/routes';
import reportsRoutes from '../modules/reports/routes';
import quizRoutes from '../modules/quiz/routes';
import isAuthorized from './hooks/isAuthorized';
import isGuest from './hooks/isGuest';
import defaultIsGuest from './hooks/defaultIsGuest';
import locale from '../lang/locale';

Vue.use(Router);


let routes = [].concat([
	{
		path: '/',
    name: 'default',
		beforeEnter: defaultIsGuest,
	},

  {
    path: '/auth/register',
    name: 'signup',
    component: Signup,
    beforeEnter: isGuest,
  },

  {
    path: '/auth/login',
    name: 'login',
    component: LoginForm,
    beforeEnter: isGuest,
  },

  {
    path: '/auth/password/reset',
    name: 'password-recovery-send-token',
    component: SendResetTokenForm,
    beforeEnter: isGuest,
  },

  {
    path: '/auth/password/reset/:token',
    name: 'password-recovery-reset-password',
    component: ResetPasswordForm,
    beforeEnter: isGuest,
    props: true,
  },

  {
    path: '/contact-us',
    name: 'contact_us',
    component: ContactUsForm,
  },

  {
    path: '/error',
    name: 'error',
    component: ErrorPage,
  },{
    path: '/404',
    name: '404',
    component: ErrorPage,
  }, {
    path: '*',
    redirect: '/404'
  }

], dashboardRoutes, clientRoutes, therapistRoutes, reportsRoutes, protocolRoutes, profileRoutes, quizRoutes);

export default new Router({
  mode: 'history',
  routes: routes,
  base: `/${locale}/`,
});



// WEBPACK FOOTER //
// ./src/router/index.js